import CampSettingsEditor from '@/pages/backend/components/CampSettingsEditor/index';
import { FC, useMemo, useRef, useState } from 'react';
import { useEventListener } from 'ahooks/es';

const RichCom: FC<{
  toggleIsFullScreen: (isFullScreen: boolean) => void;
  id: any;
  defaultValue?: string;
  onChange: (content: any) => void;
}> = ({ defaultValue, onChange, id, toggleIsFullScreen }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const ref = useRef<any>(null);
  const content = useMemo(() => {
    if (defaultValue && typeof defaultValue === 'string') {
      try {
        return JSON.parse(defaultValue);
      } catch (e) {
        return '';
      }
    }
    return '';
  }, [defaultValue]);

  useEventListener(
    'click',
    (e) => {
      const target = ref.current?.querySelector('.extra-tool-wrapper');
      if (target?.contains(e.target)) {
        setIsFullScreen(!isFullScreen);
        toggleIsFullScreen(!isFullScreen);
      }
    },
    {
      target: ref,
    },
  );
  return (
    <div id={`rich_text_${id}`} ref={ref}>
      <CampSettingsEditor content={content} style={{ height: '200px' }} onChange={onChange} />
    </div>
  );
};
export default RichCom;
